/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { ServerConfig } from '@/types/app-config';

const config: ServerConfig = {
  apiBaseUrl: 'http://asuat.dominiomayoral.es:10188',
  graphql: {
    introspection: true,
    playground: true,
  },
};

export default config;
